import React, { useState, useEffect } from 'react';
import Styles from './PublicLabView.module.scss';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export default function LpathView({ data }) {

    const [expandedLabId, setExpandedLabId] = useState(data?.labs?.[0]?.id || null);
    const [expandedNodeIds, setExpandedNodeIds] = useState({});
    const [expandedTimelineNodes, setExpandedTimelineNodes] = useState({});
    const [hasAutoExpanded, setHasAutoExpanded] = useState(false);
    
    useEffect(() => {
        if (!hasAutoExpanded && data?.labs?.length) {
            const firstLabId = data.labs[0].id;
            setExpandedLabId(firstLabId);
            setHasAutoExpanded(true);
        }
    }, [data, hasAutoExpanded]);


    return (
        <div id='nodesContainer' className={Styles.nodesContainer}>
            {data?.labs?.map((lab) => {
                const isLabExpanded = expandedLabId === lab.id;
                const expandedNodeId = expandedNodeIds[lab.id];

                return (
                    <div key={lab.id} id={`labCard_${lab.id}`} className={Styles.labCard}>
                        <div
                            id={`labHeader_${lab.id}`}
                            className={Styles.labHeader}
                            onClick={() => {
                                setExpandedLabId(isLabExpanded ? null : lab.id);
                            }}
                            style={{ cursor: "pointer" }}
                        >
                            <div id={`labLeft_${lab.id}`} className={Styles.labLeft}>
                                <div id={`labIconContainer_${lab.id}`} className={Styles.labIconContainer}>
                                    <img alt={lab.name} src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${lab.icon}`} />
                                </div>
                                <span id={`labTitle_${lab.id}`} className={Styles.labTitle}>{lab.name}</span>
                            </div>
                            <button
                                id={`labExpandBtn_${lab.id}`}
                                className={Styles.expandButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setExpandedLabId(isLabExpanded ? null : lab.id);
                                }}
                            >
                                {isLabExpanded ? (
                                    <ExpandLessIcon className={Styles.chevronIcon} fontSize="small" />
                                ) : (
                                    <ExpandMoreIcon className={Styles.chevronIcon} fontSize="small" />
                                )}
                            </button>
                        </div>

                        {isLabExpanded && (
                            <div id={`nodesGrid_${lab.id}`} className={Styles.nodesGrid}>
                                {lab.nodes?.map((node) => {
                                    const isNodeExpanded = expandedNodeId === node.id;

                                    return (
                                        <div
                                            key={node.id}
                                            id={`nodeCard_${node.id}`}
                                            className={`${Styles.nodeCard} ${isNodeExpanded ? Styles.nodeCardExpanded : ""}`}
                                        >
                                            <div
                                                id={`nodeHeader_${node.id}`}
                                                className={Styles.nodeHeader}
                                                onClick={() => {
                                                    setExpandedNodeIds((prev) => ({
                                                        ...prev,
                                                        [lab.id]: isNodeExpanded ? null : node.id,
                                                    }));
                                                    setExpandedTimelineNodes((prev) => ({
                                                        ...prev,
                                                        [node.id]: false,
                                                    }));
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div id={`nodeIconContainer_${node.id}`} className={Styles.nodeIconContainer}>
                                                    <img alt={node.name} src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${node.icon}`} />
                                                </div>
                                                <span id={`nodeTitle_${node.id}`} className={Styles.nodeTitle}>{node.name}</span>
                                                <button
                                                    id={`nodeExpandBtn_${node.id}`}
                                                    className={Styles.expandButton}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setExpandedNodeIds((prev) => ({
                                                            ...prev,
                                                            [lab.id]: isNodeExpanded ? null : node.id,
                                                        }));
                                                        setExpandedTimelineNodes((prev) => ({
                                                            ...prev,
                                                            [node.id]: false,
                                                        }));
                                                    }}
                                                >
                                                    {isNodeExpanded ? (
                                                        <ExpandLessIcon className={Styles.chevronIcon} fontSize="small" />
                                                    ) : (
                                                        <ExpandMoreIcon className={Styles.chevronIcon} fontSize="small" />
                                                    )}
                                                </button>
                                            </div>

                                            {isNodeExpanded && (
                                                <>
                                                    <ul id={`timelineList_${node.id}`} className={Styles.timelineList}>
                                                        {(expandedTimelineNodes[node.id]
                                                            ? node.steps
                                                            : node.steps.slice(0, 5)
                                                        )?.map((timeline, index) => (
                                                            <li
                                                                key={index}
                                                                id={`timelineItem_${node.id}_${index}`}
                                                                className={Styles.timelineItem}
                                                            >
                                                                {timeline}
                                                            </li>
                                                        ))}
                                                    </ul>

                                                    {node.steps.length > 5 && (
                                                        <button
                                                            id={`showMoreBtn_${node.id}`}
                                                            className={Styles.showMoreButton}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setExpandedTimelineNodes((prev) => ({
                                                                    ...prev,
                                                                    [node.id]: !prev[node.id],
                                                                }));
                                                            }}
                                                        >
                                                            {expandedTimelineNodes[node.id]
                                                                ? "Show Less"
                                                                : "Show More"}
                                                        </button>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
